export default __webpack_public_path__ + "static/media/resetpwd.cc4e3b72.png";